module.exports = __webpack_public_path__ + "img/pic_2.59d32f14.jpg";